import { put, call, select } from 'redux-saga/effects'
import { isLoading, modalIsLoading, pageIsLoading } from 'domain/loading'
import { transformData } from './helpers'
import { EducationInterface } from 'pages/Recruiter/Candidates/AddEditProfile/types'
import * as Actions from './actions'
import * as M from 'domain/env'
import Api from 'domain/api'
import I from 'immutable'

export function* ensureEducationsList() {
  const headers = yield select(M.userToken)
  if (!headers) return
  try {
    const {
      data: { data }
    } = yield call(Api.getEducationsList, {
      headers: { Authorization: `Bearer ${headers}` }
    })
    yield put({
      type: Actions.educationsList.success,
      payload: I.fromJS(data)
    })
  } catch (err) {
    yield put({
      type: Actions.educationsList.failure,
      err
    })
  }
}

export function* ensureAddEducation({ payload }: { payload: EducationInterface; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  try {
    yield put({ type: modalIsLoading, payload: true })
    const {
      data: { data }
    } = yield call(Api.postEducations, {
      headers: { Authorization: `Bearer ${headers}` },
      data: transformData(payload)
    })
    yield put({ type: Actions.addEducation.SUCCESS, payload: I.fromJS(data) })
    yield put({ type: Actions.educationsList.type })
  } catch (err) {
    yield put({
      type: Actions.addEducation.FAILURE,
      err
    })
  } finally {
    yield put({ type: modalIsLoading, payload: false })
  }
}

export function* ensureEducation({ payload }: { payload: number; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  yield put({ type: isLoading, payload: true })
  yield put({ type: pageIsLoading, payload: true })
  try {
    const {
      data: { data }
    } = yield call(Api.getEducation, {
      headers: { Authorization: `Bearer ${headers}` },
      id: payload
    })
    yield put({ type: Actions.education.success, payload: I.fromJS(data) })
  } catch (err) {
    yield put({
      type: Actions.education.failure,
      err
    })
  } finally {
    yield put({ type: isLoading, payload: false })
    yield put({ type: pageIsLoading, payload: false })
  }
}

export function* ensureUpdateEducation({ payload }: { payload: EducationInterface; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  try {
    yield put({ type: modalIsLoading, payload: true })
    const {
      data: { data }
    } = yield call(Api.putEducation, {
      headers: { Authorization: `Bearer ${headers}` },
      id: payload.id,
      data: transformData(payload)
    })
    yield put({ type: Actions.updateEducation.SUCCESS, payload: I.fromJS(data) })
    yield put({ type: Actions.educationsList.type })
  } catch (err) {
    yield put({
      type: Actions.updateEducation.FAILURE,
      err
    })
  } finally {
    yield put({ type: modalIsLoading, payload: false })
  }
}

export function* ensureRemoveEducation({ payload }: { payload: number; type: string }) {
  const headers = yield select(M.userToken)
  if (!headers) return
  try {
    yield put({ type: modalIsLoading, payload: true })
    const {
      data: { data }
    } = yield call(Api.deleteEducation, {
      headers: { Authorization: `Bearer ${headers}` },
      id: payload
    })
    yield put({ type: Actions.removeEducation.SUCCESS, payload: I.fromJS(data) })
    yield put({ type: Actions.educationsList.type })
  } catch (err) {
    yield put({
      type: Actions.removeEducation.FAILURE,
      err
    })
  } finally {
    yield put({ type: modalIsLoading, payload: false })
  }
}
